module.exports = __webpack_public_path__ + "static/media/camera_view_bottom.851ee269.svg";